// extracted by mini-css-extract-plugin
module.exports = {"root":"loading-indicator_root__xn7kD","circle":"loading-indicator_circle__17H-9"};